import React from "react";
import { getPrismic } from "../utils/get-prismic";
import { DetailLayout } from "../components/detail-layout";

const PageEvent = ({ pageData, latestImpact }) => {
  const { title } = pageData.data;

  // For Breadcrumbs component
  const breadcrumbLinks = [
    {
      link: { internal: true, href: "/impact", as: "/impact" },
      title: "Impact"
    },
    { title: title }
  ];

  const related = {
    title: "Latest Impact Stories",
    cta: "See All Impact Stories",
    link: { internal: true, href: "/impact", as: "/impact" },
    items: latestImpact.map(impact => {
      const { image, title } = impact.data;
      return {
        link: {
          internal: true,
          href: `/impact-detail?uid=${impact.uid}`,
          as: `/impact/${impact.uid}`
        },
        image: image,
        title: title
      };
    })
  };

  return (
    <DetailLayout
      related={related}
      breadcrumbLinks={breadcrumbLinks}
      {...pageData.data}
    />
  );
};

PageEvent.getInitialProps = async context => {
  const { uid: value } = context.query;
  const fragment = "my.impact.uid";
  const pageData = await getPrismic({ fragment, value, context });
  const latestImpact = await getPrismic({
    fragment: "document.type",
    value: "impact",
    context,
    multiple: true,
    options: {
      orderings: "[my.impact.first_publication_date desc]",
      pageSize: 3
    }
  });
  return { pageData, latestImpact };
};

export default PageEvent;
